// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cursor-pointer[data-v-a44fb9d8] {\n    cursor: pointer;\n}\n.card-body[data-v-a44fb9d8] {\n    font-size: 0.9rem;\n}\n", ""]);
// Exports
module.exports = exports;
